<template>
  <div class="pt-4 sm:pt-0 pl-10 px-8">
    <h1 class="text-sm text-white text-center font-bold">{{ auth.username }}</h1>
    <div
      v-if="opened"
      class="py-3 flex flex-col">
      <button
        @click="toggleUpdatePassword()"
        class="flex items-center px-1 py-1 mb-3 text-white border border-gray-400 rounded-md hover:text-gray-400">
        <i class="material-icons text-xl">chevron_right</i>
        <span class="text-sm">Ganti Password</span>
      </button>
      <button
        @click="logout()"
        class="flex items-center px-1 py-1 mb-3 text-white border border-gray-400 rounded-md hover:text-gray-400">
        <i class="material-icons text-xl">chevron_right</i>
        <span class="text-sm">Logout</span>
      </button>
    </div>
    <div
      v-if="updatePassword"
      class="mt-3">
      <h1 class="flex items-center px-1 py-1 mb-3 text-white border border-gray-400 rounded-md">
        <i
          @click="toggleUpdatePassword()"
          class="material-icons text-xl text-green-500 hover:text-gray-400 cursor-pointer">chevron_left</i>
        <span class="text-white text-sm">Ganti Password</span>
      </h1>
      <div class="py-3 px-3">
        <FormUpdatePassword />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FormUpdatePassword from './FormUpdatePassword.vue'

export default {
  name: 'MenuProfile',
  data: () => ({
    opened: true,
    updatePassword: false
  }),
  computed: {
    ...mapGetters(['auth'])
  },
  components: {
    FormUpdatePassword
  },
  methods: {
    ...mapActions(['toLogout']),
    toggleUpdatePassword: function () {
      this.opened = this.opened ? false : true
      this.updatePassword = this.updatePassword ? false : true
    },
    logout: function () {
      this.toLogout()
      this.$router.push({ path: '/salmontrack/login' })
    }
  }
}
</script>
